import React, { Component } from 'react';
import Axios from 'axios';
import PropTypes from 'prop-types';
import Colors from '../../../styles/colors';
import commonStyles from '../../../styles/commonStyles';
import Toggle from 'material-ui/Toggle';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { OrangeSubmitButton } from '../../../components/buttons/buttons';
import Spinner from 'react-activity/lib/Spinner';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { STATIC_HOMEPAGE_URL } from '../../../config';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { publisherManager } from '../../../helpers/managers';
import { hasUserExceededPodcastFeedLimit } from '../../../helpers/userinfoHelper';
import { ALERTS } from '../../../helpers/texts';
const isNewSoundcast = id => id === 'CREATE_NEW';
const isSoundcastDoesNotExist = id => isEmpty(id) || isNewSoundcast(id);

const { podcastCategories } = require('../../../../server/scripts/utils.js')();
const itunesCategories = {};
Object.keys(podcastCategories).forEach((i, index) => {
  const item = podcastCategories[i];
  let sub = false;
  if (Object.keys(item.subCategories).length) {
    sub = [];
    Object.keys(item.subCategories).forEach(j => sub.push(item.subCategories[j].name));
  }
  itunesCategories[`${index}`] = { name: item.name, sub };
});

class SaveConvertSubmitButton extends OrangeSubmitButton {}
SaveConvertSubmitButton.propTypes = {
  onClick: PropTypes.func,
  styles: PropTypes.object,
};

function SaveConvertButton(props) {
  const { label, onClick, isLoading = false } = props;
  const nlabel = isLoading ? (
    <div style={{ marginTop: 5, marginBottom: -9 }}>
      <Spinner size={16} speed={1} />
    </div>
  ) : (
    label
  );
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <SaveConvertSubmitButton
        label={nlabel}
        onClick={onClick}
        styles={{
          fontSize: '13px',
          letterSpacing: '1px',
          wordSpacing: '2px',
          margin: '35px 0 30px',
          paddingRight: '10px',
          paddingLeft: '10px',
          height: '35px',
          paddingTop: '2px',
          backgroundColor: Colors.link,
          borderWidth: '0px',
        }}
      />
    </div>
  );
}

export default class YoutubeConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      savingSettings: false,
      fileUploaded: false,
    };

    // this.optionsUpdated = false;
    this.currentImageRef = null;
    this.fileInputRef = null;
    this.ituneImage = '';

    this.setStateSafe = this.setStateSafe.bind(this);
    // this.areOptionsUpdated = this.areOptionsUpdated.bind(this);
    this.saveItunesImage = this.saveItunesImage.bind(this); // ??? not used
    this.deleteConversion = this.deleteConversion.bind(this);
    this.doDeleteConversion = this.doDeleteConversion.bind(this);
    this.onSelectIntroOutro = this.onSelectIntroOutro.bind(this);
    this.changeSoundcastId = this.changeSoundcastId.bind(this);
    this.onSelectOptimisevolume = this.onSelectOptimisevolume.bind(this);
    this.onSelectTrimSilence = this.onSelectTrimSilence.bind(this);
    this.changePlaylistId = this.changePlaylistId.bind(this);
    this.changeItune1 = this.changeItune1.bind(this);
    this.changeItune2 = this.changeItune2.bind(this);
    this.changeItune3 = this.changeItune3.bind(this);
    this.displayToggleOrUrl = this.displayToggleOrUrl.bind(this);
    this.displayFeedOptions = this.displayFeedOptions.bind(this);
    this.displayConnectVideos = this.displayConnectVideos.bind(this);
    this.setFileName = this.setFileName.bind(this);
    this.displayItunesImage = this.displayItunesImage.bind(this);
    this.displayAudioProcessing = this.displayAudioProcessing.bind(this);
    this.addIntroOutro = this.addIntroOutro.bind(this);
    this.renderItunes = this.renderItunes.bind(this);
  }

  isComponentMounted = false;

  setStateSafe(state) {
    if (this.isComponentMounted) {
      this.setState(state);
    }
  }

  componentDidMount() {
    this.isComponentMounted = true;
    this.onMountOrReceiveProps(this.props, null);
  }

  componentWillUnmount = () => {
    this.isComponentMounted = false;
  };

  componentWillReceiveProps(nextProps) {
    this.onMountOrReceiveProps(null, nextProps);
  }

  onMountOrReceiveProps(currentProps, nextProps) {
    const props = currentProps || nextProps || {};
    if (props.connected && props.soundcast_Id && !this.propsLoaded) {
      this.propsLoaded = true; // lock
      this.displayItunesImage(props.connectedSoundcast);
    }
  }

  // // TODO  options from props should come from publisher.
  // areOptionsUpdated() {
  //   const optionFromProps = this.props.soundcastFromYoutube;
  //
  //   const optionsFromstate = {
  //     itunesExplicit: this.props.itunesExplicit,
  //     itune1: this.props.itune1,
  //     itune2: this.props.itune2,
  //     itune3: this.props.itune3,
  //     setVolume: this.props.setVolume,
  //     trimSilence: this.props.trimSilence,
  //     introOutro: this.props.introOutro,
  //     overlayDuration: this.props.overlayDuration,
  //   };
  //
  //   if (!isEqual(optionFromProps, optionsFromstate)) {
  //     this.optionsUpdated = true;
  //   }
  //   if (optionFromProps == null) {
  //     this.optionsUpdated = true;
  //   }
  // }

  // upload new image to S3/Firebase
  async saveItunesImage(soundcastId) {
    if (!this.currentImageRef || isSoundcastDoesNotExist(soundcastId)) {
      return null;
    }
    let data = new FormData();
    const splittedFileName = this.currentImageRef.type.split('/');
    const ext = splittedFileName[splittedFileName.length - 1];
    let fileName = `${soundcastId}-${moment().format('x')}.${ext}`;
    data.append('file', this.currentImageRef, fileName);
    return new Promise(resolve => {
      Axios.post('/api/upload', data)
        .then(res => {
          // POST succeeded...
          //replace 'http' with 'https'
          let url = res.data[0].url;
          if (url.slice(0, 5) !== 'https') {
            url = url.replace(/http/i, 'https');
          }
          this.currentImageRef = null;
          this.ituneImage = url;
          this.setStateSafe({ fileUploaded: false });
          resolve(url);
        })
        .catch(err => {
          // POST failed...
          console.log('ERROR upload to aws s3: ', err);
          resolve('');
        });
    });
  }

  deleteConversion() {
    this.props.showAlert({
      content: 'Are you sure you want to delete this conversion?',
      confirm: {
        ok: {
          text: 'DELETE',
          onClick: () => {
            this.doDeleteConversion();
          },
        },
        cancel: {
          text: 'CANCEL',
        },
      },
    });
  }

  doDeleteConversion() {
    const { userInfo, soundcast_Id, newSoundcastId } = this.props;
    this.props.deleteConversion();
    const soundcastId = isSoundcastDoesNotExist(soundcast_Id) ? newSoundcastId : soundcast_Id;
    Axios.post('/api/parse_channel', {
      publisherId: userInfo.publisherID,
      creatorId: userInfo.id,
      soundcastId,
      deleteChannelSubscription: true,
      skipChannelConversion: true,
    })
      .then(result => {
        publisherManager.removeProp(userInfo.publisherID, `youtubeConnect/${soundcastId}`);
        window.open(`https://myaccount.google.com/permissions?pli=1`, `_blank`); // revoke google access page
      })
      .catch(err => {
        console.error(`Error: deleteConversion POST parse_channel ${err}`);
        window.open(`https://myaccount.google.com/permissions?pli=1`, `_blank`); // revoke google access page
      });
  }

  onSelectIntroOutro() {
    // UI will not respond if nothing selected.
    const { soundcast_Id, introOutro } = this.props;
    if (soundcast_Id) {
      const managed = this.props.userInfo && this.props.userInfo.soundcasts_managed;
      if (managed && managed[soundcast_Id] && managed[soundcast_Id].intro) {
        this.props.updateRequest({ introOutro: !introOutro });
      } else {
        this.props.openModal(soundcast_Id);
      }
    }
  }

  onToggleCreatePodcastFeed() {
    const { updateRequest, createPodcastFeed, showAlert } = this.props;
    if (hasUserExceededPodcastFeedLimit()) {
      return showAlert({
        title: 'Upgrade Required',
        content: ALERTS().ALLOWED_PODCAST_FEEDS.LIMIT_EXCEEDED,
        upgrade: true,
      });
    }

    updateRequest({ createPodcastFeed: !createPodcastFeed });
  }

  changeSoundcastId(e) {
    // When soundcast changed, get the information from publishers/soundcastFromYoutube and soundcasts
    // update states related to soundcast, do not update playlistName, playlistId and ChannelName as
    // those are not related to a particular soundcast.

    let soundcast_Id = e.target.value;
    const { userInfo } = this.props;
    const managed = userInfo && userInfo.soundcasts_managed;
    const selectedSoundcast = isSoundcastDoesNotExist(soundcast_Id)
      ? null
      : (managed && managed[soundcast_Id]) || null;

    // Message for basic plan users to upgrade on selecting new soundcast.
    let nowTime = Math.floor(new Date().getTime() / 1000);
    if (
      isNewSoundcast(soundcast_Id) &&
      userInfo.publisher.plan == 'basic' &&
      userInfo.publisher.current_period_end < nowTime
    ) {
      return this.props.showAlert({
        content: [
          'You’ve already filled the soundcast quota of your current plan.',
          <br key="youtube-soundcast-quota-br" />,
          'Please upgrade to add new soundcasts.',
        ],
        upgrade: true,
      });
    }

    // Get the itunesCategory
    const categoryLength =
      selectedSoundcast &&
      selectedSoundcast.itunesCategory &&
      selectedSoundcast.itunesCategory.length;
    const ituneCat1 = categoryLength > 0;
    const ituneCat2 = categoryLength > 1;
    const ituneCat3 = categoryLength > 2;

    // Get information from publishers - soundcastFromYoutube
    // Get the current playlistName and options saved.
    const { soundcastFromYoutube } = this.props;
    let audioProcessingOptions = {};
    let optionsPresent = false;

    if (soundcastFromYoutube && soundcastFromYoutube.audioProcessingOptions) {
      optionsPresent = true;
      audioProcessingOptions = soundcastFromYoutube.audioProcessingOptions;
    }

    // Get if the material contains explicit language. We aren't using this from soundcast,
    // instead we pick up the value set by the server in audioProcessingOptions. So below code is commented.
    // const explicit = connectedSoundcast.itunesExplicit;

    const itunesExplicit =
      optionsPresent && audioProcessingOptions.itunesExplicit
        ? audioProcessingOptions.itunesExplicit
        : true;
    const setVolume = audioProcessingOptions.setVolume;
    const trimSilence = audioProcessingOptions.trim;
    const introOutro = audioProcessingOptions.intro || audioProcessingOptions.outro;
    const overlayDuration = audioProcessingOptions.overlayDuration
      ? audioProcessingOptions.overlayDuration
      : '';

    this.props.updateRequest({
      soundcast_Id,
      itunesExplicit,
      itune1: ituneCat1 ? selectedSoundcast.itunesCategory[0] : '',
      itune2: ituneCat2 ? selectedSoundcast.itunesCategory[1] : '',
      itune3: ituneCat3 ? selectedSoundcast.itunesCategory[2] : '',
      setVolume,
      trimSilence,
      introOutro,
      overlayDuration,
      createPodcastFeed: false,
    });

    // Handle the image
    this.currentImageRef = null;
    selectedSoundcast && this.displayItunesImage(selectedSoundcast);
  }

  onSelectOptimisevolume() {
    this.props.updateRequest({ setVolume: !this.props.setVolume });
  }

  onSelectTrimSilence() {
    this.props.updateRequest({ trimSilence: !this.props.trimSilence });
  }

  changePlaylistId(e) {
    this.props.updateRequest({ playlistId: e.target.value });
  }

  changeItune1(e) {
    this.props.updateRequest({ itune1: e.target.value });
  }

  changeItune2(e) {
    this.props.updateRequest({ itune2: e.target.value });
  }

  changeItune3(e) {
    this.props.updateRequest({ itune3: e.target.value });
  }

  showOptions() {
    const { submitFeed, updateRequest } = this.props;
    return (
      <div style={{ fontSize: '16px', paddingTop: 14 }}>
        <RadioButtonGroup
          name="radioSumbitFeed"
          defaultSelected={submitFeed}
          onChange={(e, value) => updateRequest({ submitFeed: value })}>
          <RadioButton
            value={true}
            label="Submit the feed for me to Apple Podcasts, Google Podcasts, and Spotify"
            labelStyle={{
              ...styles.titleText,
              lineHeight: '25px',
              fontWeight: 500,
              color: '#474747',
            }}
            style={{ ...styles.radioButton, marginBottom: 8 }}
          />
          <RadioButton
            value={false}
            label="I will submit the feed myself"
            labelStyle={{
              ...styles.titleText,
              lineHeight: '25px',
              fontWeight: 500,
              color: '#474747',
            }}
            style={styles.radioButton}
          />
        </RadioButtonGroup>
      </div>
    );
  }

  displayItunesImage(soundcast = {}) {
    this.setStateSafe({ fileUploaded: false });

    let img = new Image();
    img.onload = () => {
      let height = img.naturalHeight || img.height;
      let width = img.naturalWidth || img.width;
      if (height >= 1400 && height <= 3000 && width >= 1400 && width <= 3000) {
        // the size is good.
      } else {
        // the size isn't good so blank it out.
        this.ituneImage = '';
      }
    };

    this.ituneImage = soundcast.itunesImage || soundcast.imageURL;
    img.src = this.ituneImage;
  }

  displayFeedOptions(soundcast = {}) {
    const { itunesExplicit, updateRequest, itune1, itune2, itune3 } = this.props;
    const categoryObj = itunesCategories;
    const itunesArr = [];
    const ituneImage = this.ituneImage || soundcast.itunesImage || soundcast.imageURL || '';
    for (let key in categoryObj) {
      if (categoryObj[key].sub) {
        categoryObj[key].sub.forEach(sub => {
          itunesArr.push(`${categoryObj[key].name} - ${sub}`);
        });
      } else {
        itunesArr.push(categoryObj[key].name);
      }
    }
    itunesArr.unshift('');
    return (
      <div style={{ padding: '10px 10px 10px 0px' }}>
        <div style={{ ...styles.titleText, paddingTop: 6, paddingBottom: 17 }}>
          The material contains explicit language
        </div>

        <RadioButtonGroup
          name="Contains explicit language"
          defaultSelected={itunesExplicit}
          onChange={(e, value) => updateRequest({ itunesExplicit: value })}>
          <RadioButton
            value={true}
            label="Yes"
            labelStyle={{ ...styles.titleText, lineHeight: '25px', color: '#474747' }}
            style={{ ...styles.radioButton, marginBottom: 9 }}
          />
          <RadioButton
            value={false}
            label="No"
            labelStyle={{ ...styles.titleText, lineHeight: '25px', color: '#474747' }}
            style={styles.radioButton}
          />
        </RadioButtonGroup>

        <div style={{ marginTop: 20, height: 150 }}>
          <div style={styles.image}>
            <img alt="Image" src={ituneImage} />
          </div>
          <div style={styles.loaderWrapper}>
            <div style={{ ...styles.titleText, marginLeft: 10 }}>Podcast cover art</div>
            <div style={{ ...styles.fileTypesLabel, marginLeft: 10 }}>
              At least 1400 x 1400 pixels in .jpg or .png format. Must not exceed 3000 x 3000 pixels
            </div>
            <div style={{ ...styles.inputFileWrapper, marginTop: 0 }}>
              <input
                type="file"
                name="upload"
                id="upload_hidden_cover"
                accept="image/*"
                onChange={this.setFileName}
                style={styles.inputFileHidden}
                ref={input => (this.fileInputRef = input)}
              />
              {(this.state.fileUploaded && this.fileInputRef && (
                <div>
                  <span>{this.fileInputRef.files[0] && this.fileInputRef.files[0].name}</span>
                  <span
                    style={styles.cancelImg}
                    onClick={() => {
                      this.setStateSafe({ fileUploaded: false });
                      this.ituneImage = '';
                      this.fileInputRef.value = null;
                    }}>
                    Cancel
                  </span>
                </div>
              )) ||
                (!this.state.fileUploaded && (
                  <div>
                    <button
                      onClick={() => this.fileInputRef.click()}
                      style={{ ...styles.uploadButton, backgroundColor: Colors.link }}>
                      Upload
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {this.renderItunes('iTunes Category 1', this.changeItune1, itune1, itunesArr, true)}
        {this.renderItunes('iTunes Category 2', this.changeItune2, itune2, itunesArr, false)}
        {this.renderItunes('iTunes Category 3', this.changeItune3, itune3, itunesArr, false, '0px')}
        {this.showOptions()}
      </div>
    );
  }

  renderItunes(label, onChange, value, itunesArr, required, marginBottom) {
    return (
      <div style={{ width: 'auto', marginBottom: marginBottom || '10px' }} className="dropdown">
        <div
          style={{ width: '100%', padding: 0 }}
          className="btn dropdown-toggle"
          data-toggle="dropdown">
          <div style={{ ...styles.dropdownTitle, paddingLeft: 0 }}>
            <div style={{ display: 'flex' }}>
              <span>{label}</span>
              {required ? <span style={{ color: 'red', textAlign: 'left' }}>*</span> : null}
            </div>
            <select style={styles.itunesStyle} onChange={onChange} value={value}>
              {itunesArr.map((itune, i) => {
                return (
                  <option style={styles.option} value={itune} key={i}>
                    {itune}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>
    );
  }

  addIntroOutro() {
    const { soundcast_Id, introOutro, overlayDuration } = this.props;
    if (isSoundcastDoesNotExist(soundcast_Id)) {
      return null;
    }

    return (
        <div>
          <div style={{ display: 'flex' }}>
            <Toggle
              label=""
              toggled={introOutro}
              onClick={this.onSelectIntroOutro}
              thumbSwitchedStyle={styles.thumbSwitched}
              trackSwitchedStyle={styles.trackSwitched}
              style={{ fontSize: 20, width: '11%' }}
            />
            <span style={{ fontWeight: 'bold' }}>Attach intro/outro</span>
          </div>

          {introOutro ? (
            <div style={{ display: 'flex', marginLeft: '63px', marginTop: '10px' }}>
              <p style={{ fontSize: '14px' }}>Overlap with main audio:</p>
              <div style={{ marginLeft: '10px', marginRight: '10px', width: '14%' }}>
                <input
                  type="text"
                  style={{ ...styles.inputTitle, height: '30px', fontSize: '14px' }}
                  onChange={e => this.props.updateRequest({ overlayDuration: e.target.value })}
                  value={overlayDuration}
                />
              </div>
              <p style={{ fontSize: '14px' }}>second(s)</p>
            </div>
          ) : null}
        </div>
    );
  }

  displayAudioProcessing() {
    return (
      <div>
        <p
          style={{
            padding: '10px 0px 0px 0px',
            fontWeight: 'bold',
            marginBottom: '8px',
            fontSize: '16px',
          }}>
          Audio Processing Options
        </p>
        <div style={{ fontSize: '16px' }}>
          <div style={{ display: 'flex' }}>
            <Toggle
              label=""
              toggled={this.props.setVolume}
              onClick={this.onSelectOptimisevolume}
              thumbSwitchedStyle={styles.thumbSwitched}
              trackSwitchedStyle={styles.trackSwitched}
              style={{ fontSize: 20, width: '11%' }}
            />
            <span style={{ fontWeight: 'bold' }}>Optimize volume</span>
          </div>

          <div style={{ display: 'flex' }}>
            <Toggle
              label=""
              toggled={this.props.trimSilence}
              onClick={this.onSelectTrimSilence}
              thumbSwitchedStyle={styles.thumbSwitched}
              trackSwitchedStyle={styles.trackSwitched}
              style={{ fontSize: 20, width: '11%' }}
            />
            <span style={{ fontWeight: 'bold' }}>Trim silence at beginning and end</span>
          </div>
          {this.addIntroOutro()}
        </div>
      </div>
    );
  }

  displayToggleOrUrl() {
    const { userInfo } = this.props;
    const id = this.props.soundcast_Id;
    const soundcasts_managed = (userInfo && userInfo.soundcasts_managed) || {};

    //show toggle if it is a new soundcast
    const newSoundcast = isNewSoundcast(id);
    //show toggle is soundcast is not for sale
    let feedAllowed = !newSoundcast && id && soundcasts_managed[id] && !soundcasts_managed[id].forSale;
    //show toggle if the page isn't private
    feedAllowed =
      feedAllowed &&
      soundcasts_managed[id] &&
      soundcasts_managed[id].landingPage &&
      soundcasts_managed[id].landingPage == true;
    //show toggle if there is no URL already
    let NoUrlExists =
      feedAllowed && soundcasts_managed[id] && !soundcasts_managed[id].podcastFeedVersion;

    const feedOptionsSoundcast = newSoundcast
      ? { imageURL: `https://dummyimage.com/300.png/979797/ffffff&text=%20NEW%20` }
      : soundcasts_managed[id];

    if ((feedAllowed && NoUrlExists) || newSoundcast) {
      return (
        <div>
          <div style={{ display: 'flex' }}>
            <Toggle
              label=""
              toggled={this.props.createPodcastFeed}
              onClick={() => this.onToggleCreatePodcastFeed()}
              thumbSwitchedStyle={styles.thumbSwitched}
              trackSwitchedStyle={styles.trackSwitched}
              style={{ fontSize: 20, width: '11%' }}
            />
            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Create a podcast feed for the soundcast
            </span>
          </div>
          {this.props.createPodcastFeed && this.displayFeedOptions(feedOptionsSoundcast)}
        </div>
      );
    }

    if (feedAllowed && !NoUrlExists && !newSoundcast) {
      return (
        <div>
          <p style={{ fontSize: '16px' }}>
            <strong>Your podcast feed URL is:</strong>
            <a href={`${STATIC_HOMEPAGE_URL}/rss/${id}`} style={{ color: Colors.mainOrange }}>
              {` ${STATIC_HOMEPAGE_URL}/rss/${id}`}
            </a>
          </p>
          {this.displayFeedOptions(soundcasts_managed[id])}
        </div>
      );
    }
  }

  displayConnectVideos(soundcasts) {
    const {
      userInfo,
      requested,
      soundcast_Id,
      channel,
      channelName,
      playlistId,
      playlists,
    } = this.props;
    const youtubeConnect =
      (userInfo && userInfo.publisher && userInfo.publisher.youtubeConnect) || {};
    const soundcastFromYoutube =
      (userInfo && userInfo.publisher && userInfo.publisher.soundcastFromYoutube) || {};
    const connectedPlaylistIds = [];
    let isUploadedVideosConnected = false;
    Object.entries(soundcastFromYoutube).forEach(pair => {
      const { playlistId } = pair[1];
      if (isEmpty(playlistId)) {
        isUploadedVideosConnected = true;
      } else {
        connectedPlaylistIds.push(playlistId);
      }
    });
    return (
      <div>
        <div style={{ display: 'flex' }}>
          {channel.id && requested == 'NEVERCONNECTED' && (
            <p style={{ fontSize: '16px', paddingTop: 5, wordBreak: 'break-word' }}>
              Your channel{' '}
              <strong>{(channel.snippet && channel.snippet.title) || channelName}</strong> is{' '}
              <span style={{ color: Colors.mainOrange, fontSize: '14px' }}>connected</span>
            </p>
          )}
        </div>
        <div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
          <span
            style={{
              ...styles.titleText,
              padding: '10px 10px 10px 0px',
              width: '120px',
              marginRight: '16',
              flex: '2',
            }}>
            Connect videos from
          </span>
          <div style={{ width: 'auto', flex: '4' }} className="dropdown">
            <div
              style={{ width: '100%', padding: 0 }}
              className="btn dropdown-toggle"
              data-toggle="dropdown">
              <select
                style={{ ...styles.dropdownTitle, borderColor: 'white' }}
                onChange={e => this.changePlaylistId(e)}
                value={playlistId}>
                <option
                  style={{ ...styles.titleText, padding: '20px' }}
                  value={''}
                  disabled={isUploadedVideosConnected}>
                  {isUploadedVideosConnected ? '[CONNECTED] ' : ''}Uploaded videos
                </option>
                {Array.isArray(playlists) &&
                  playlists.map((playList, i) => {
                    const isPlayListConnected = connectedPlaylistIds.includes(playList.id);
                    // playList.status.privacyStatus (string) 'public' || 'private' || 'unlisted'
                    const playListPrivacyStatus = get(playList, 'status.privacyStatus', 'public');
                    const isPlayListNotPublic = playListPrivacyStatus !== 'public';

                    const itemCount = get(playList, 'contentDetails.itemCount', 0);
                    const isPlayListEmpty = itemCount <= 0;

                    const youtubeStateRender = isPlayListConnected
                      ? `[CONNECTED] `
                      : isPlayListNotPublic
                      ? `[${playListPrivacyStatus}] `
                      : isPlayListEmpty
                      ? `[empty] `
                      : '';

                    const isPlayListDisabled =
                      isPlayListConnected || isPlayListNotPublic || isPlayListEmpty;
                    return (
                      <option
                        style={styles.option}
                        value={playList.id}
                        key={i}
                        disabled={isPlayListDisabled}>
                        {youtubeStateRender + playList.snippet.title}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '20px' }}>
          <span
            style={{
              ...styles.titleText,
              padding: '10px 10px 10px 0px',
              width: '120px',
              marginRight: '16',
              flex: '2',
            }}>
            to tracks in
          </span>
          <div style={{ width: 'auto', flex: '4' }} className="dropdown">
            <div
              style={{ width: '100%', padding: 0 }}
              className="btn dropdown-toggle"
              data-toggle="dropdown">
              <select
                style={{ ...styles.dropdownTitle, borderColor: 'white' }}
                onChange={e => this.changeSoundcastId(e)}
                value={soundcast_Id}>
                <option style={styles.option} value={''} key={'select'}>
                  Select Soundcast
                </option>
                {soundcasts.map((souncast, i) => {
                  const youtubeState = youtubeConnect[souncast.id] || '';
                  const youtubeStateRender = isEmpty(youtubeState) ? '' : `[${youtubeState}] `;
                  return (
                    <option
                      style={styles.option}
                      value={souncast.id}
                      key={i}
                      disabled={youtubeState === 'CONNECTED'}>
                      {youtubeStateRender + souncast.title}
                    </option>
                  );
                })}
                <option style={styles.option} value={'CREATE_NEW'}>
                  A new soundcast
                </option>
              </select>
            </div>
          </div>
        </div>
        <p style={{ fontSize: '14px' }}>(Up to 50 latest videos in initial conversion)</p>
      </div>
    );
  }

  displayConnectedStatus() {
    const { connected, userInfo, channelName, playlistName, soundcast_Id } = this.props;
    const showPlaylistName = playlistName != '' ? `(${playlistName})` : '';
    const managedTitle =
      userInfo &&
      userInfo.soundcasts_managed &&
      userInfo.soundcasts_managed[soundcast_Id] &&
      userInfo.soundcasts_managed[soundcast_Id].title;
    const soundcastTitle = connected ? managedTitle || '' : '';
    return (
      <div style={{ fontSize: 16, fontWeight: 'bold' }}>
        {`The ${channelName}'s channel ${showPlaylistName} is 
          being converted to tracks in ${soundcastTitle}`}
        <div style={{ marginBottom: '35px' }} />
      </div>
    );
  }

  setFileName() {
    var img, allowedFileTypes;
    var _URL = window.URL || window.webkitURL;
    if (this.fileInputRef.files[0]) {
      img = new Image();
      img.onload = () => {
        var width = img.naturalWidth || img.width;
        var height = img.naturalHeight || img.height;
        if (height < 1400 || height > 3000 || width < 1400 || width > 3000) {
          this.ituneImage = '';
          return this.props.showAlert({
            content: [
              'iTunes image size must be between 1400 x 1400 px and 3000 x 3000 px.',
              <br key="youtube-image-size-br" />,
              'Please upload a new image.',
            ],
          });
        } else {
          this.setStateSafe({
            fileUploaded: true,
            imageType: 'cover',
          });

          this.currentImageRef = this.fileInputRef.files[0];
          allowedFileTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
          if (allowedFileTypes.indexOf(this.currentImageRef.type) < 0) {
            return this.props.showAlert({
              content: [
                'Only .png or .jpeg files are accepted.',
                <br key="youtube-allowed-files-br" />,
                'Please upload a new file.',
              ],
            });
          }
        }
      };
      this.ituneImage = _URL.createObjectURL(this.fileInputRef.files[0]);
      img.src = this.ituneImage;
    }
  }

  render() {
    const { requested, connected, writeData, connectionRequest, soundcast_Id, newSoundcastId } = this.props;
    const soundcastId = isSoundcastDoesNotExist(soundcast_Id) ? newSoundcastId : soundcast_Id;
    const { savingSettings } = this.state;
    const soundcasts = Object.values(this.props.soundcastsManaged);
    return (
      <MuiThemeProvider>
        <div style={{ width: '100%' }}>
          {!connected && requested === 'REQUESTED' && (
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>
              {"Channel conversion is in progress. We'll email you when conversion is done."}
            </div>
          )}
          {connected && this.displayConnectedStatus()}

          {!connected && requested !== 'REQUESTED' && this.displayConnectVideos(soundcasts)}

          {(requested === 'NEVERCONNECTED' || requested === 'DISCONNECTED' || connected) && (
            <div style={{ marginBottom: '10px' }}>
              {this.displayToggleOrUrl()}
              {this.displayAudioProcessing()}
              <div style={{ display: `flex` }}>
                <div style={{ display: `inline-flex` }}>
                  <OrangeSubmitButton
                    label="Delete conversion"
                    onClick={this.deleteConversion}
                    styles={{
                      fontSize: '13px',
                      letterSpacing: '1px',
                      wordSpacing: '2px',
                      margin: '35px 17px 0px',
                      padding: '0px 10px',
                      height: '35px',
                      backgroundColor: Colors.mainWhite,
                      color: Colors.mainOrange,
                      borderColor: Colors.mainOrange,
                      borderWidth: '2px',
                    }}
                  />
                  {connected && (
                    <SaveConvertButton
                      isLoading={savingSettings}
                      label={'Save' /* Convert */}
                      onClick={async e => {
                        this.setStateSafe({ savingSettings: true });
                        const itunesImage = await this.saveItunesImage(soundcastId);
                        await writeData(e, true, [{ ...connectionRequest, itunesImage }]);
                        this.setStateSafe({ savingSettings: false });
                      }}
                    />
                  )}
                  {!connected && requested !== 'REQUESTED' && (
                    <SaveConvertButton
                      isLoading={savingSettings}
                      label={'Save' /* Save Settings */}
                      onClick={async e => {
                        if (soundcast_Id === '') {
                          return this.props.showAlert({
                            content: 'Please select a soundcast.',
                          });
                        }
                        this.setStateSafe({ savingSettings: true });
                        const itunesImage = await this.saveItunesImage(soundcastId);
                        await writeData(e, false, [{ ...connectionRequest, itunesImage }]);
                        this.setStateSafe({ savingSettings: false });
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          <hr style={{ marginBottom: 45, borderTop: `1px solid #d0d0d0` }} />
        </div>
      </MuiThemeProvider>
    );
  }
}

const styles = {
  backDrop: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0px',
    left: '0px',
    right: '0px',
    zIndex: '9998',
    background: 'rgba(0, 0, 0, 0.3)',
  },
  image: { ...commonStyles.image, float: 'left', background: Colors.blankPicGrey },
  titleText: { ...commonStyles.titleText },
  dropdownTitle: { ...commonStyles.dropdownTitle },
  itunesStyle: {
    ...commonStyles.dropdownTitle,
    borderColor: '#e6e6e6',
    color: '#474747',
    marginBottom: '0px',
  },
  thumbSwitched: { backgroundColor: Colors.link },
  trackSwitched: { backgroundColor: Colors.link },
  cancelImg: { ...commonStyles.cancelImg },
  loaderWrapper: {
    ...commonStyles.loaderWrapper,
    width: 'calc(100% - 133px)',
    float: 'left',
    paddingTop: 13,
  },
  inputFileHidden: { ...commonStyles.inputFileHidden },
  uploadButton: {
    backgroundColor: Colors.link,
    width: 80,
    height: 30,
    color: Colors.mainWhite,
    fontSize: 14,
    border: 0,
    marginTop: 5,
    marginLeft: 10,
  },
  fileTypesLabel: {
    fontSize: 14,
    marginLeft: 0,
    display: 'block',
  },
  modal: {
    position: 'absolute',
    top: '55%',
    left: '50%',
    width: '70%',
    height: '25vh',
    transform: 'translate(-50%, -50%)',
    zIndex: '9999',
    background: '#fff',
  },
  radioButton: {
    marginBottom: 16,
  },
};
